module.exports = __webpack_public_path__ + "img/logo_nav.44d821ac.png";